import React from 'react';
import configuration from './config.js';

var ClientLogo ;

 
	ClientLogo = () => (
		<div>
	        <img src={configuration.logos + 'clients/logo_' + JSON.parse(localStorage.getItem("user")).client + '.png'}  alt="" 
	        	style={{"maxHeight": '300px', 
	        			"marginLeft": "auto",
  						"marginRight": "auto",
  						
  						}}  />
		</div>
	);
 

export default  ClientLogo ;
